import React from "react";
import Header from "./header";
import {
  Box,
  Typography,
  Paper,
  Container,
  Grid,
  useTheme,
  useMediaQuery,
  Link,
} from "@mui/material";
import backgroundImg from "../assets/background.jpg";
import googleImg from "../assets/google.png";
import trustImg from "../assets/trust.png";
import yelpImg from "../assets/yelp.png";
// import AccidentAssessmentForm from "./assessment";
import AccidentAssessmentForm from "../components/forms/AccidentAssessmentForm";
import Footer from "./footer";
import { useParams } from "react-router-dom";
import { extractNumber } from "../utils/helper";
import TextBox from "../components/textbox";
import CountdownTimer from "../components/countdown";

const HomePage: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { funnelSource } = useParams<{ funnelSource?: string }>();

  const sourceNumber = extractNumber(funnelSource);

  return (
    <>
      <Header />
      <Box
        sx={{
          backgroundImage: `url(${backgroundImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          width: "100%",
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          position: "relative",
          padding: "2rem 0",
        }}
      >
        <Container maxWidth="lg">
          {/* Main Heading */}
          {sourceNumber === 2 && (
            <>
              <Typography
                variant={isMobile ? "h5" : "h4"}
                align="center"
                sx={{
                  color: "white",
                  fontWeight: "bold",
                  textShadow: "2px 2px 4px rgba(0, 0, 0, 0.6)",
                  mt: 0,
                  fontSize: {
                    xs: "1.1rem",
                    sm: "1.1rem",
                    md: "1.7rem",
                  },
                }}
              >
                Claim maximum compensation for your <br />
                <span
                  style={{
                    textDecoration: "underline",
                    textDecorationColor: "#ff6b35",
                    textDecorationThickness: "3px",
                  }}
                >
                  damaged car, medical bills, and injuries.
                </span>{" "}
              </Typography>
              {/* Assessment Text */}
              <Typography
                variant="h6"
                align="center"
                sx={{
                  color: "white",
                  textShadow: "1px 1px 3px rgba(0, 0, 0, 0.6)",
                  mb: isMobile ? 1 : 3,
                  mt: isMobile ? 1 : 3,
                  fontSize: {
                    xs: "1rem",
                    sm: "1rem",
                    md: "1.3rem",
                  },
                }}
              >
                Inform us about your accident to schedule your{" "}
                <span style={{ color: "#ff6b35", fontWeight: "bold" }}>
                  FREE CONSULTATION
                </span>{" "}
                <span>with our trusted personal injury lawyers.</span>
              </Typography>
            </>
          )}
          {sourceNumber !== 2 && (
            <>
              <Typography
                variant={isMobile ? "h5" : "h4"}
                align="center"
                sx={{
                  color: "white",
                  fontWeight: "bold",
                  textShadow: "2px 2px 4px rgba(0, 0, 0, 0.6)",
                  mt: 0,
                  fontSize: {
                    xs: "1.3rem",
                    sm: "1.3rem",
                    md: "1.7rem",
                  },
                }}
              >
                Receive{" "}
                <span
                  style={{
                    textDecoration: "underline",
                    textDecorationColor: "#ff6b35",
                    textDecorationThickness: "3px",
                  }}
                >
                  Maximum Accident Injury Payout
                </span>{" "}
                with the Help of
              </Typography>

              <Typography
                variant={isMobile ? "h6" : "h4"}
                align="center"
                sx={{
                  color: "white",
                  fontWeight: "bold",
                  textShadow: "2px 2px 4px rgba(0, 0, 0, 0.6)",
                  mb: isMobile ? 1 : 2,
                  fontSize: {
                    xs: "1.3rem",
                    sm: "1.3rem",
                    md: "1.7rem",
                  },
                }}
              >
                Trusted Personal Injury Lawyers
              </Typography>

              {/* Assessment Text */}
              <Typography
                variant="h6"
                align="center"
                sx={{
                  color: "white",
                  textShadow: "1px 1px 3px rgba(0, 0, 0, 0.6)",
                  mb: isMobile ? 1 : 3,
                  fontSize: {
                    xs: "0.9rem",
                    sm: "0.9rem",
                    md: "1.2rem",
                  },
                }}
              >
                Take this quick assessment to get a{" "}
                <span style={{ color: "#ff6b35", fontWeight: "bold" }}>
                  FREE CASE CONSULTATION
                </span>{" "}
                and{" "}
                <span style={{ color: "#ff6b35" }}>
                  know how much is owed to you
                </span>
              </Typography>
            </>
          )}

          {/* {sourceNumber === 3 && <TextBox />} */}
          <Box
            sx={{
              backgroundColor: "rgba(240, 240, 240, 0.7)", // Transparent grey
              borderRadius: 4,
              mx: "auto",
              maxWidth: "700px",
              textAlign: "center",
            }}
          >
            {/* Counter */}
            <CountdownTimer
              duration={120}
              isAnswered={false}
              bannerMessage="Skip the line for instant connection with a specialist by completing the questions before the time limit."
              timerSx={{
                fontSize: "1.5rem",
                color: "#fff",
              }}
              containerSx={{
                mb: 4,
              }}
            />
          </Box>

          {/* Assessment Form - now using the multi-step form component */}

          {sourceNumber !== 6 && (
            <Paper
              elevation={3}
              sx={{
                pt: 2,
                pb: 4,
                pl: 4,
                pr: 4,
                borderRadius: 2,
                mb: 4,
                width: "100%",
                maxWidth: "800px",
                mx: "auto",
              }}
            >
              <AccidentAssessmentForm sourceNumber={sourceNumber ?? 0} />
            </Paper>
          )}

          {sourceNumber === 6 && (
            <Paper
              elevation={3}
              sx={{
                pt: 2,
                pb: 4,
                pl: 4,
                pr: 4,
                borderRadius: 2,
                mb: 4,
                width: "100%",
                maxWidth: "800px",
                mx: "auto",
              }}
            >
              <AccidentAssessmentForm
                sourceNumber={6}
                skipSteps={["INJURY", "REPRESENTATION", "FAULT"]}
                defaultValues={{
                  physicalInjury: "YES",
                  treatedBy: "YES", // Set your desired default
                  hasAttorney: "NO", // Set your desired default
                  accidentFault: "NO", // Set your desired default
                }}
              />
            </Paper>
          )}

          {/* Free Consultation Text */}
          <Typography
            variant="subtitle1"
            align="center"
            sx={{
              color: "white",
              fontWeight: "medium",
              textShadow: "1px 1px 3px rgba(0, 0, 0, 0.6)",
              mb: 3,
            }}
          >
            FREE No Obligation Consultation Pay Nothing!
          </Typography>

          {/* Rating Text */}
          <Typography
            variant="h6"
            align="center"
            sx={{
              color: "white",
              fontWeight: "bold",
              textShadow: "1px 1px 3px rgba(0, 0, 0, 0.6)",
              mb: 3,
            }}
          >
            Our Expert Lawyers Have Been Rated 5-stars
          </Typography>

          {/* Review Logos */}
          <Grid container spacing={2} justifyContent="center" sx={{ mb: 4 }}>
            <Grid item xs={12} sm={4}>
              <img
                src={yelpImg}
                alt="Yelp"
                style={{
                  height: "100px",
                  marginLeft: isMobile ? "18%" : "10%",
                  marginBottom: "8px",
                }}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <img
                src={googleImg}
                alt="Google"
                style={{
                  height: "100px",
                  marginLeft: isMobile ? "18%" : "10%",
                  marginBottom: "8px",
                }}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <img
                src={trustImg}
                alt="Trustpilot"
                style={{
                  height: "100px",
                  marginLeft: isMobile ? "18%" : "10%",
                  marginBottom: "8px",
                }}
              />
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Container sx={{ mt: "2%" }} maxWidth="md">
        <Typography
          sx={{ mb: "10px", textAlign: "center" }}
          variant="subtitle1"
        >
          By clicking on the "Next" button above, you consent, acknowledge, and
          agree to the following: Our{" "}
          <Link
            href="https://www.caraccidentcounsel.com/terms-of-service/"
            sx={{ color: "#05b1eb" }}
          >
            Terms of Service
          </Link>{" "}
          and Privacy Policy. That you are providing express "written" consent
          for caraccidentcounsel.com or its{" "}
          <Link
            href="https://www.caraccidentcounsel.com/network-of-lawyers-and-advocates/"
            sx={{ color: "#05b1eb" }}
          >
            network of lawyers and advocates to
          </Link>{" "}
          call you (autodialing, text and pre-recorded messaging for
          convenience) via telephone, mobile device (including SMS and MMS -
          charges may apply depending on your carrier, not by us, messaging
          frequency varies; text HELP for help; text STOP to cancel), even if
          your telephone number is currently listed on any internal, corporate,
          state or federal Do-Not-Call list. We take your privacy seriously and
          you may receive electronic communications, including periodic emails
          with important news, financial tips, tools and more. You can always
          unsubscribe at any time. All website interactions and phone calls are
          recorded for compliance and quality assurance purposes. Consent is not
          required as a condition to utilize caraccidentcounsel.com services and
          you are under no obligation to purchase anything.
        </Typography>
        <Typography
          sx={{ mb: "10px", textAlign: "center" }}
          variant="subtitle1"
        >
          This site is not a part of the Facebook website or Facebook Inc.
          Additionally, This site is NOT endorsed by Facebook in any way.
          FACEBOOK is a trademark of FACEBOOK, Inc.
        </Typography>
        <Typography
          sx={{ mb: "10px", textAlign: "center" }}
          variant="subtitle1"
        >
          This site is not a part of the YouTube website or Google, LLC.
          Additionally, This site is NOT endorsed by Google in any way. YouTube
          is a trademark of Google, LLC.
        </Typography>
        <Typography
          sx={{ mb: "10px", textAlign: "center" }}
          variant="subtitle1"
        >
          PAID ATTORNEY ADVERTISEMENT: This Website is a group advertisement. It
          is not a lawyer referral service or prepaid legal services plan. This
          website is not a law firm. The sole basis for the inclusion of the
          participating lawyers or law firms is the payment of a fee for
          exclusive geographical advertising rights. A complete list of our
          joint advertising attorneys can be found here:{" "}
          <Link
            href="https://www.caraccidentcounsel.com/sponsors/"
            sx={{ color: "#05b1eb" }}
          >
            Sponsors
          </Link>{" "}
          You can request an attorney by name. Our company does not endorse or
          recommend any lawyer or law firm who participates in the network. It
          does not make any representation and has not made any judgment as to
          the qualifications, expertise or credentials of any participating
          lawyer. The information contained herein is not legal advice. Any
          information you submit to this website may not be protected by
          attorney-client privilege. All photos are of models and do not depict
          clients. All case evaluations are performed by participating
          attorneys. This website is for informational purposes only. By filling
          out the free consultation form, you are NOT forming an attorney-client
          relationship. You can only retain a lawyer by entering into a written
          retainer agreement with an attorney. Our services may not be available
          in all states.
        </Typography>
      </Container>
      <Footer />
    </>
  );
};

export default HomePage;
